/**
 * P2-05 · Block background tokens — a leaf module so block config schemas can
 * reuse them without importing the registry (which imports every block back,
 * a runtime cycle). Maps to theme tokens in the storefront `HomeSection`.
 */
import { z } from "zod";

export const BLOCK_BACKGROUNDS = ["default", "subtle", "primary", "dark"] as const;
export const blockBackgroundSchema = z.enum(BLOCK_BACKGROUNDS);
export type BlockBackground = (typeof BLOCK_BACKGROUNDS)[number];
